import React from "react";
import styled from "styled-components";

export default styled.div`
    float: left;
    width: 50%;
    margin-top: 35px;
`;